/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useModal } from '../../contexts/ModalsContext';
import AddToFavoritesButton from '../buttons/AddToFavorites';
import FilmTitle from '../partials/FilmTitle';
import Image from '../partials/Image';

import styles from '../../../styles/headers/film.module.scss';

const propTypes = {
    item: AppPropTypes.film.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const FilmHeader = ({ item, className }) => {
    const { trailer = null, image = null, url = null } = item;
    const { url: imageUrl = null } = image || {};
    const { url: trailerUrl = null, provider } = trailer || {};
    const validTrailer =
        trailerUrl !== null &&
        (provider === 'youtube' || provider === 'vimeo' || provider === 'embed');
    const { colors = null } = image || {};
    const [fromColor = null, toColor = null] = colors || [];
    const { setModal } = useModal();

    const setFilmModal = useCallback(
        (e) => {
            e.preventDefault();
            setModal({ type: 'film', item, trailerOnly: true });
        },
        [setModal, item],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.noImage]: imageUrl === null,
                },
            ])}
            style={{
                backgroundImage: `linear-gradient(135deg, ${fromColor} 0%, ${toColor} 100%)`,
            }}
        >
            <div className={styles.inner}>
                <div className={styles.content}>
                    <FilmTitle
                        className={styles.info}
                        titleClassName={styles.title}
                        alternateTitleClassName={styles.alternateTitle}
                        metaClassName={styles.meta}
                        directorsClassName={styles.directors}
                        item={item}
                    />
                </div>
                <div className={styles.buttons}>
                    <AddToFavoritesButton
                        className={classNames(styles.button, styles.favoriteButton)}
                        iconClassName={styles.buttonIcon}
                        item={item}
                        loginNext={url}
                        withoutLabel
                        isDark
                    />
                    {validTrailer ? (
                        <button
                            type="button"
                            className={styles.trailerButton}
                            onClick={setFilmModal}
                        >
                            <div className={styles.trailerBtnIconContainer}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    className={styles.trailerBtnIconPlay}
                                >
                                    <polygon
                                        points="28.8 24 56.8 40 28.8 56 28.8 24"
                                        fill="currentColor"
                                    />
                                </svg>
                            </div>
                            <FormattedMessage defaultMessage="Trailer" description="Button label" />
                        </button>
                    ) : null}
                </div>
            </div>
            <Image
                className={styles.backgroundPoster}
                imageClassName={styles.backgroundImg}
                media={image}
                fit
                cover
            />
        </div>
    );
};

FilmHeader.propTypes = propTypes;
FilmHeader.defaultProps = defaultProps;

export default FilmHeader;
